const dataState = {
  mainComputationData: {
    "Tax Adjustments": [],
    "Tax adjustment (separate sourced income)": [],
    "Tax adjustment (balancing charge)": [],
    "Further deduction s14n": [],
    "Further deduction other": [],
    "Current Year Capital Allowances": [],
    "Unutilised Capital Allowances": [],
    "Unutilised Losses": [],
    "Unutilised Donations": [],
    "Other Source Income": [],
    "Current Year Donations": [],
    "Current Year Investment Losses": [],
    "Partial Tax Exemption / Full Tax Exemption": [],
    "Corporate Income Tax Rebate": {},
    "Tax Previously Assessed": [{ date: "", amount: 0, historyAmount: [] }],
    isStartup: false,
    comments: null,
    reviewNote: null,
    unsaved: false,
  },
  detailPL: {
    Revenue: [],
    "Other Income": [],
    "Cost of Sales": [],
    Expenses: [],
    flipSignMode: {
      Revenue: "positive",
      "Other Income": "positive",
      "Cost of Sales": "positive",
      Expenses: "positive",
    },
    comments: "",
    reviewNote: "",
    netProfitBeforeTax: 0,
    unsaved: false,
  },
  Savy: {
    scheduleTitle: "",
    rows: [],
    comments: "",
    taxAdjustment: "Added Back",
    section: "Tax Adjustments",
    spreadSheetData: null,
    unsaved: false,
  },
  "Partial Breakdown": {
    scheduleId: "",
    scheduleTitle: "",
    rows: [],
    notes: "",
    reviewNotes: "",
    totalAdjustment: 0,
    unsaved: false,
  },
  "Full Breakdown": {
    scheduleId: "",
    scheduleTitle: "",
    rows: [],
    notes: "",
    reviewNotes: "",
    totalAdjustment: 0,
    unsaved: false,
  },
  "FAAdditions": {
    scheduleId: "",
    dataRows: [],
    otherSourceRows: [],
    totalRenovation: 0,
    totalRevenue: 0,
    notes: "",
    reviewNotes: "",
    unsaved: false,
  },
  "caSettings": {
    caSettings: [],
    unsaved: false,
  }
};

const dataReducer = (prevState, action) => {
  switch (action.type) {
    case "UPDATE_DATA":
      return {
        ...prevState,
        [action.section]: {
          ...prevState[action.section],
          ...action.payload,
        },
      };

    case "RESET_DATA":
      return {
        ...prevState,
        [action.section]: { ...dataState[action.section] }, // Reset a specific section
      };

      case "RESET_ALL_DATA":
        return { ...dataState };

    case "LOGOUT":
      return { ...dataState }; // Reset everything to default

    default:
      return prevState;
  }
};

export { dataState, dataReducer };
